/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RoleResponse } from "./RoleResponse";
import {
    RoleResponseFromJSON,
    RoleResponseFromJSONTyped,
    RoleResponseToJSON,
} from "./RoleResponse";
import type { PermissionResponse } from "./PermissionResponse";
import {
    PermissionResponseFromJSON,
    PermissionResponseFromJSONTyped,
    PermissionResponseToJSON,
} from "./PermissionResponse";

/**
 *
 * @export
 * @interface RolesResponse
 */
export interface RolesResponse {
    /**
     * True if this is the complete list of roles & permissions. This is the case if you are allowed to see all tags in the system (ie you are admin AND mineOnly=false)
     * @type {boolean}
     * @memberof RolesResponse
     */
    isComplete?: boolean;
    /**
     *
     * @type {Array<RoleResponse>}
     * @memberof RolesResponse
     */
    roles?: Array<RoleResponse>;
    /**
     *
     * @type {Array<PermissionResponse>}
     * @memberof RolesResponse
     */
    permissions?: Array<PermissionResponse>;
}

/**
 * Check if a given object implements the RolesResponse interface.
 */
export function instanceOfRolesResponse(value: object): value is RolesResponse {
    return true;
}

export function RolesResponseFromJSON(json: any): RolesResponse {
    return RolesResponseFromJSONTyped(json, false);
}

export function RolesResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RolesResponse {
    if (json == null) {
        return json;
    }
    return {
        isComplete: json["isComplete"] == null ? undefined : json["isComplete"],
        roles:
            json["roles"] == null
                ? undefined
                : (json["roles"] as Array<any>).map(RoleResponseFromJSON),
        permissions:
            json["permissions"] == null
                ? undefined
                : (json["permissions"] as Array<any>).map(
                      PermissionResponseFromJSON,
                  ),
    };
}

export function RolesResponseToJSON(value?: RolesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        isComplete: value["isComplete"],
        roles:
            value["roles"] == null
                ? undefined
                : (value["roles"] as Array<any>).map(RoleResponseToJSON),
        permissions:
            value["permissions"] == null
                ? undefined
                : (value["permissions"] as Array<any>).map(
                      PermissionResponseToJSON,
                  ),
    };
}
